export default () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="3" fill="#0A66C2" />
        <path d="M6.94 8.86H3.9V20.1H6.94V8.86ZM5.42 3.9C4.44 3.9 3.65 4.69 3.65 5.67C3.65 6.65 4.44 7.44 5.42 7.44C6.4 7.44 7.19 6.65 7.19 5.67C7.19 4.69 6.4 3.9 5.42 3.9ZM20.1 14.02C20.1 10.76 18.36 9.24 16.03 9.24C14.15 9.24 13.31 10.27 12.85 11V9.24H9.8V20.1H12.85V14.2C12.85 12.54 13.16 11.3 14.79 11.3C16.39 11.3 16.65 12.54 16.65 14.28V20.1H20.1V14.02Z" fill="white" />
    </svg>
);
